import React from 'react'
import Left from './left'
import Right from './right'

function Market() {

  return (
    <div className="marker-body">
      <Left />
      <Right />
    </div>
  )
}

export default Market
